// What an assistant sees: the Tasks page for their clinic, a small header with
// their name and Sign out, and nothing else (docs/ASSISTANT-LOGIN-SPEC.md).
// No nav, no other pages, no calls the server would refuse. Signs itself out
// after 30 minutes with no mouse or keyboard use.
import type { JSX } from 'preact';
import { useEffect } from 'preact/hooks';
import { session } from '../lib/session';
import { signOut } from '../lib/auth';
import { TasksPage } from '../pages/Tasks';

export const ASSISTANT_IDLE_MS = 30 * 60 * 1000;

export function endAssistantSession(): void {
  void signOut();
  session.value = { status: 'signed-out', me: null, error: null };
}

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'] as const;

export function AssistantShell(): JSX.Element {
  const name = session.value.me?.displayName ?? 'Assistant';

  useEffect(() => {
    let timer = window.setTimeout(endAssistantSession, ASSISTANT_IDLE_MS);
    const reset = (): void => {
      window.clearTimeout(timer);
      timer = window.setTimeout(endAssistantSession, ASSISTANT_IDLE_MS);
    };
    for (const ev of ACTIVITY_EVENTS) window.addEventListener(ev, reset, { passive: true });
    return () => {
      window.clearTimeout(timer);
      for (const ev of ACTIVITY_EVENTS) window.removeEventListener(ev, reset);
    };
  }, []);

  return (
    <div class="assistant-shell" data-testid="assistant-shell">
      <header class="assistant-shell__header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 16px">
        <strong data-testid="assistant-name">{name}</strong>
        <button type="button" class="sign-out-button" data-testid="assistant-signout" onClick={endAssistantSession}>
          Sign out
        </button>
      </header>
      <TasksPage />
    </div>
  );
}
